import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BrandingService } from '@app/@shared/services/branding.service';

@Component({
  selector: 'app-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss'],
})
export class TabBarComponent implements OnInit {
  currentRoute: string = '';

  constructor(private router: Router, public brandingService: BrandingService) {}

  ngOnInit(): void {
    this.router.events.subscribe(() => {
      this.currentRoute = this.router.url;
    });
  }

  navigateTo(route: string): void {
    this.router.navigate([route], { queryParamsHandling: 'preserve' });
  }

  isActive(route: string): boolean {
    return this.currentRoute === route;
  }
}
